



































import Enumerable from "linq";
import { HospitalizationHistoryInformation } from "../../../domain/his";
import { Component, Mixins, Prop, Emit, Watch } from "vue-property-decorator";
import { ElTable, SortOrder } from "element-ui/types/table";
import { ISortParameter } from "../../system";
import { TableColumn } from "element-ui/types/table-column";
import { Comparator } from "../../../domain/system";

interface IHistoryColumn {
  toValue: ToValueType;
}

type ToValueType = (s: HospitalizationHistoryInformation) => string;

@Component
export default class HospitalizationHistorySelector extends Mixins() {
  @Prop()
  histories: HospitalizationHistoryInformation[];
  
  tableData: HospitalizationHistoryInformation[] = [];
  defaultSort: ISortParameter = {
    property: "admissionDate",
    order: "descending",
  };

  private static readonly _columns: { [key: string]: IHistoryColumn; } = {
    admissionDate: { toValue: s => s.admissionDateText ? s.admissionDateText : "" },
    dischargeDate: { toValue: s => s.dischageDateText ? s.dischageDateText : "" },
    department: { toValue: s => s.department ? s.department.name : "" },
    doctor: { toValue: s => s.doctors 
      ? Enumerable.from(s.doctors).select(d => d.name).toArray().join(",")
      : "" },
  };

  data(): any {
    return {
      sortParameter: null,
    };
  }
  sortParameter: ISortParameter;

  $refs!: {
    table: ElTable,
  };

  mounted() {
    this.tableData = this.histories;
    this.sortParameter = this.defaultSort;
  }

  toAdmissionDate(row: HospitalizationHistoryInformation): string {
    if (!row.admissionDate) { return ""; }
    return this.toDateString(row.admissionDate);
  }

  toDischargeDate(row: HospitalizationHistoryInformation): string {
    if (!row.dischargeDate) { return ""; }
    return this.toDateString(row.dischargeDate);
  }

  toDepartmentName(row: HospitalizationHistoryInformation): string {
    return row.department ? row.department.name : "";
  }

  toDoctorName(row: HospitalizationHistoryInformation): string {
    if (!row.doctors) { return ""; }
    return Enumerable.from(row.doctors).select(d => d.name).toArray().join(",");
  }

  onSortChanged(param: { column: TableColumn, prop: string, order: SortOrder }): void {
    this.sortParameter = {
      property: param.prop,
      order: param.order ? param.order : "ascending",
    };
  }

  updateSort(): void {
    if (this.$refs.table && this.sortParameter) {
      this.$refs.table.sort(this.sortParameter.property, this.sortParameter.order);
      this.tableData.sort((a, b): number => {
        const toValue = HospitalizationHistorySelector._columns[this.sortParameter.property].toValue;
        return Comparator.compare(toValue(a), toValue(b), this.sortParameter.order === "ascending");
      });
    }
  }

  clearSelected(): void {
    if (!this.$refs.table) { return; }
    // setCurrentRow()で選択行がリセットされないため、代替としてdataの入れ直しで対応する
    this.tableData = [];
    this.$nextTick(() => this.tableData = this.histories);
  }

  private toDateString(date: Date): string {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1);
    const day = String(date.getDate());
    return year.toString() + " / " + month + " / " + day;
  }

  @Watch("sortParameter")
  onSortParameterUpdated(newValue: ISortParameter, oldValue: ISortParameter): void {
    if (!oldValue || (newValue.property !== oldValue.property || newValue.order !== oldValue.order)) {
      this.updateSort();
    }
  }

  @Watch("histories")
  onHistoriesChanged(newValue: HospitalizationHistoryInformation[], oldValue: HospitalizationHistoryInformation[]): void {
    if (newValue === oldValue) { return; }
    this.tableData = this.histories;
    this.sortParameter = this.defaultSort;
  }

  @Emit()
  historySelectionChanged(history: HospitalizationHistoryInformation): void {}
}
